import { removeLSItem } from "util/localStorageUtils";
import { logoutAuth } from "../../api/auth/logoutAuth";
import { logoutSuccess } from "./logoutSuccess";
import { refresh } from "./refresh";

export function logout() {
  if (window.google && window.google?.accounts?.id?.disableAutoSelect) {
    // To Record the status in cookies. This prevents a UX dead loop
    google.accounts.id.disableAutoSelect();
  }

  return (dispatch: any) => {
    logoutAuth().then(() => {
      dispatch(refresh());
      dispatch(logoutSuccess());
      removeLSItem("email");
      removeLSItem("emailSha");
    });
  };
}
